import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    usuarios: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    presupuestoInternoId: 0,
    ordenTrabajoId: 0,
    usuariosList: [],
    usuariosPresupuesto: []
};

const mutations = {
    updateField,

    'INICIALIZAR_USUARIOS' (state) {
        state.usuarios = [];
    },
    'SET_USUARIOS' (state, usuarios) {
        state.usuarios = usuarios;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LISTAS' (state) {
        state.presupuestoInternoId = 0;
        state.ordenTrabajoId = 0;
        state.usuariosList = [];
        state.usuariosPresupuesto = [];
    },
    'SET_LISTAS' (state, params) {
        state.presupuestoInternoId = params.presupuestoInternoId;
        state.ordenTrabajoId = params.ordenTrabajoId;
        state.usuariosList = params.usuarios;

        state.usuariosList.sort(function(a, b){
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
        
    }
};

const getters = {
    getField,

    usuarios (state) {
        return state.usuarios;
    },
};

const actions = {
    getUsuariosOrden ( { commit }, ordenTrabajoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_USUARIOS');
            // console.log('getUsuarios');
            apiAxios.get('ordenestrabajosusuarios/' + ordenTrabajoId + '/usuarios')
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_USUARIOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    setUsuarioOrden ( { }, params ) {
        return new Promise((resolve, reject) => {

            let ordenTrabajoUsuario= {
                ordenTrabajoId: parseInt(params.ordenTrabajoId),
                usuarioId: parseInt(params.usuarioId),
                usuarioRolId: parseInt(params.usuarioRolId),
            };

            let url = 'ordenestrabajosusuarios';

            apiAxios.post(url, ordenTrabajoUsuario)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteUsuarioOrden ( {}, params ) {
        return new Promise((resolve, reject) => {

            let ordenTrabajoUsuario= {
                ordenTrabajoId: parseInt(params.ordenTrabajoId),
                usuarioId: parseInt(params.usuarioId),
                usuarioRolId: parseInt(params.usuarioRolId),
            };

            let url = 'ordenestrabajosusuarios/delete';

            apiAxios.post(url, ordenTrabajoUsuario)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getUsuariosAsignar ( { commit }, ordenTrabajoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LISTAS');

            apiAxios.get('ordenestrabajosusuarios/' + ordenTrabajoId)
                .then(res => {
                    // let params = res.data;
                    // params.presupuestoInternoId = presupuestoId;

                    let params = {
                        presupuestoInternoId: 0,
                        ordenTrabajoId: ordenTrabajoId,
                        usuarios: res.data
                    }

                    commit('SET_LISTAS', params);
                    resolve();
                })
                .catch(error =>  {
                    reject(error);
                })
        }, error => {
            reject(error);
        })            
    },
    setUsuariosOrden ( { state } ) {
        return new Promise((resolve, reject) => {

            let usuariosOrden = state.usuariosList
                .filter(usuario => (/true/i).test(usuario.asignado) == true
                    & (/true/i).test(usuario.asignadoPresupuesto) == false)
                .map(usuario => {
                        return {
                            usuarioId: parseInt(usuario.usuarioId),
                            usuarioRolId: parseInt(usuario.usuarioRolId),
                        }
                    });
            let usuariosAsignacion = {
                usuarios: usuariosOrden
            }

            let url = 'ordenestrabajosusuarios/' + state.ordenTrabajoId + '/usuarios';

            apiAxios.post(url, usuariosAsignacion)
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}